/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var ViewModel = function (model, settingView) {
  Base.call(this);
  this.entityType = model.get('Entity');
  this.settingView = settingView;
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.titleText = ko.computed(function () {
    var totalCount = this.selectedEntityCount();
    switch (this.entityType) {
      case 'Campaign':
        return totalCount > 1 ? i18n.getString('BidStrategySetting_Campaigns_BulkEditTitle').replace('{0}', totalCount) : i18n.getString('BidStrategySetting_Campaign_BulkEditTitle').replace('{0}', totalCount);
      case 'AdGroup':
        return totalCount > 1 ? i18n.getString('BidStrategySetting_AdGroups_BulkEditTitle').replace('{0}', totalCount) : i18n.getString('BidStrategySetting_AdGroup_BulkEditTitle').replace('{0}', totalCount);
      case 'Keyword':
        return totalCount > 1 ? i18n.getString('BidStrategySetting_Keywords_BulkEditTitle').replace('{0}', totalCount) : i18n.getString('BidStrategySetting_Keyword_BulkEditTitle').replace('{0}', totalCount);
    }
  }, this);
  this.entityHeaderName = ko.computed(function () {
    switch (this.entityType) {
      case 'Keyword':
        return i18n.getString('BulkEdit_Keyword_EntityNameHeader');
        break;
      case 'AdGroup':
        return i18n.getString('BulkEdit_AdGroup_EntityNameHeader');
        break;
      case 'Campaign':
        return i18n.getString('BulkEdit_Campaign_EntityNameHeader');
        break;
      default:
        return 'unknown entity';
        break;
    }
  }, this);
  this.showButtonBar = ko.observable(true);
  this.showCloseButton = ko.observable(false);
  this.validate = function () {
    return this.settingView.validate();
  };
};
export default ViewModel;

